import type { FC } from 'react';

import { useRouter } from 'next/router';

import { useSiteSettings } from 'hooks/useSiteSettings';

import { Body } from 'components/Body';

const Page: FC = () => {
  const router = useRouter();
  const { pages } = useSiteSettings();

  const currentPage = pages?.find((page) => page.tag === router.query.page);

  if (!currentPage?.html) return null;

  return (
    <Body hasSpacingY>
      <div dangerouslySetInnerHTML={{ __html: currentPage.html }} />
    </Body>
  );
};

export default Page;
